import React from 'react';
import { Alert } from 'antd';
import cn from 'classnames';

import formatPin from '../../../utils/formatPin';

function Description({ t, className, isActivate, description, pin }) {
  return (
    (description || !isActivate) && (
      <Alert
        className={cn('device-info-header__status', className)}
        message={
          !isActivate
            ? t('activate-device-pin') + ' ' + formatPin(pin)
            : description
        }
        type={!isActivate ? 'warning' : 'error'}
      />
    )
  );
}

export default Description;
